export default {
  models: {
    formaat: {
      client: 'client',
    },
    attributes: {
      formaat: {
        client: {
          code: null,
          name: null,
          users: '@:models.admin.user',
        },
      },
    },
  },
};
